<div class="sass-feature-badge" [class.is-old-theme]="isOldTheme">
    <div class="sass-feature-badge-circle"></div>
    <div class="sass-feature-badge-ping">
        <div #FeatureBadgePing
             class="sass-feature-badge-ping-animation"
             [style.animation-iteration-count]="iterationCount">
        </div>
    </div>
</div>
